import { Invitation, OrganizationMember, Role } from '../types'
import { supabase } from './supabaseClient'
import { getDb, refresh } from './store'

export function listMembers(organizationId: string): OrganizationMember[] {
  return getDb().members.filter((m) => m.organizationId === organizationId)
}

export function listInvitations(organizationId: string): Invitation[] {
  return getDb().invitations.filter((i) => i.organizationId === organizationId)
}

export async function inviteMember(
  organizationId: string,
  email: string,
  role: Role,
): Promise<void> {
  const { data } = await supabase.auth.getUser()
  const expires = new Date(Date.now() + 7 * 86_400_000).toISOString()
  const { error } = await supabase.from('organization_invitations').insert({
    organization_id: organizationId,
    email: email.trim().toLowerCase(),
    role,
    invited_by: data.user?.id ?? null,
    status: 'pending',
    expires_at: expires,
  })
  if (error) throw new Error(error.message)
  await refresh()
}

export async function cancelInvitation(invitationId: string): Promise<void> {
  const { error } = await supabase
    .from('organization_invitations')
    .update({ status: 'cancelled' })
    .eq('id', invitationId)
  if (error) throw new Error(error.message)
  await refresh()
}

/** Renueva la caducidad para que el enlace vuelva a ser válido. */
export async function resendInvitation(invitationId: string): Promise<void> {
  const { error } = await supabase
    .from('organization_invitations')
    .update({
      status: 'pending',
      expires_at: new Date(Date.now() + 7 * 86_400_000).toISOString(),
    })
    .eq('id', invitationId)
  if (error) throw new Error(error.message)
  await refresh()
}

export async function updateMemberRole(
  memberId: string,
  role: Role,
): Promise<void> {
  const { error } = await supabase
    .from('organization_members')
    .update({ role })
    .eq('id', memberId)
  if (error) throw new Error(error.message)
  await refresh()
}

export async function setMemberActive(
  memberId: string,
  active: boolean,
): Promise<void> {
  const { error } = await supabase
    .from('organization_members')
    .update({ status: active ? 'active' : 'disabled' })
    .eq('id', memberId)
  if (error) throw new Error(error.message)
  await refresh()
}

export async function removeMember(memberId: string): Promise<void> {
  const { error } = await supabase
    .from('organization_members')
    .delete()
    .eq('id', memberId)
  if (error) throw new Error(error.message)
  await refresh()
}
